<style scoped lang='less'>
.dialog-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.isdialog-enter-active,
.isdialog-leave-active {
    transition: all ease 0.5s;
}
.isdialog-enter,
.isdialog-leave-to {
    transform: scale(0);
    opacity: 0;
}
.content {
    height: 400px;
    width: 600px;
    background: white;
    transform-origin: 50%, 50%;
    // padding-top: 20px;
    display: flex;
    .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 400px;
        // background-color: red;
        > img {
            width: 170px;
            height: 220px;
        }
    }
    .introduce {
        width: 400px;
        height: 400px;
        padding: 40px 30px 30px 50px;
        overflow: hidden;
        overflow-y: auto;
        // background-color: blue;
        .name {
            color: #000;

            height: 50px;
            // background-color: aqua;
            font-size: 23px;
            font-weight: 700;
            text-align: left;
        }
        .text {
            color: #999;
            height: 250px;
            display: flex;
            flex-direction: column;

            > div {
                text-align: left;
                margin-bottom: 10px;
                font-size: 13px;
            }
            > div:last-child {
                padding-bottom: 50px;
            }
        }
    }
}
</style>
<template>
  <div class='dialog-box' v-show='show' @click.stop='close'>
    <transition name='isdialog'>
      <div class='content' v-if='show' @click.stop=''>
        <div class="logo">
          <img :src="thisCardInfo.img" alt="">
        </div>
        <template v-if="!en">
          <div class="introduce">
            <div class="name">{{thisCardInfo.name}}</div>
            <div class="text">
              <div v-for="(i, index) in thisCardInfo.text" :key="index">
                {{i}}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="introduce">
            <div class="name">{{thisCardInfo.en_name}}</div>
            <div class="text">
              <div v-for="(i, index) in thisCardInfo.en_text" :key="index">
                {{i}}
              </div>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>
<script>
import { HttpClient } from '../../util/http';
export default {
    components: {},
    data() {
        return {
            cardIndex: null,
            fatherData: null,
            show: false,
            form: {},
            loading: false,
            thisCardInfo: null,
            peopleDetail: [
                {
                    name: '王琰',
                    en_name: 'Yan Wang',
                    img: 'http://static.unicornselected.com/b136f110-0335-11eb-91c5-d550a48abe82.png',
                    text: [
                        '曾就职于中国信达资产管理股份有限公司，从事不良资产收购处置以及困境企业投资等工作，对全球amc成立、背景及发展趋势有一定研究。',
                        '2017年加入瑞信方正证券研究部任分析师，对策略与大消费投资有独到的见解，同时支持研究部筹建的法律及合规问题。',
                        '2018年9月作为联合创始人创立上海独易信息科技有限公司（亦名“独角汇”），力争打造中国独角兽私募股权交易第一平台。',
                    ],
                    en_text: [
                        'Yan Wang began his career at China Cinda Asset Management, where he focused on the acquisition and disposal of NPL and investment in distressed enterprises. He has developed professional insights in the historical background and development of global AMC.',
                        'In 2017, Yan served as an analyst at the research department of Credit Suisse Founder Securities, where he built expertise in A-share strategy and consumption industry. Yan was also actively involved in constructing the legal and compliance structure as well as document compiling inside the department. ',
                        'In September 2018, Yan joined Unicorn Selected as co-founder.',
                    ],
                },
                {
                    name: '邱昉',
                    en_name: 'Robert Qiu',
                    img: 'http://static.unicornselected.com/b1630a20-0335-11eb-91c5-d550a48abe82.jpeg',
                    text: [
                        '曾任职于高盛美国纽约总部，担任高级量化分析师，负责结构化产品、资产证券化产品量化建模，对金融衍生品有深入的研究。',
                        '2017年回国加入钜派投资，担任投资副总监，完成多个股权项目的投资，对私募股权领域有全面的理解，并拥有丰富的私募股权交易结构设计经验。',
                        '2018年9月创立上海独易信息科技有限公司（亦名“独角汇”），力争打造中国独角兽私募股权交易第一平台。',
                    ],
                    en_text: [
                        'Robert previously worked at Goldman Sachs & Co. (NYSE: GS) as Senior Quantitative Analyst, responsible for quantitative modeling of structuring products and ABS. He has in-depth study of financial derivatives.',
                        'Robert joined Jupai Holdings Limited (NYSE:JP) as Associate Director in 2017. He has a comprehensive understanding of Private Equity and is very experienced in PE Secondary market.',
                        'In September 2018, Robert joined Unicorn Selected as founder and CEO, striving to build a pioneer information platform focusing on the transactions of unicorn private equity interests.',
                    ],
                },
                {
                    name: '肖建学',
                    en_name: 'Jianxue Xiao',
                    img: 'http://static.unicornselected.com/b1995c60-0335-11eb-91c5-d550a48abe82.png',
                    text: [
                        '2004年至2014年先后于全国人大常委会、中国证监会任职，对并购重组监管政策有深刻的理解和把握。',
                        '2014年10月于中植企业集团任职，负责投资和并购工作，主导北陆药业（300016）、贵人鸟（603555）的并购，牵头收购宇顺电子（002289）并出任董事长，任职期间主持对上市公司负债、业务和资产的整合，成功解决羁绊宇顺电子多年的股东之争，并剥离了上市公司亏损资产，使宇顺电子摘除了ST，成功保壳。',
                        '2015年担任恒大金融集团总裁助理兼资产管理中心总经理，负责证券、信托和公募基金公司牌照收购工作。近期，正在协助四川泸州市政府对泸天化（ 000912 ）的破产重整和改革脱困工作。',
                        '2018年9月作为联合创始人创立上海独易信息科技有限公司（亦名“独角汇”），力争打造中国独角兽私募股权交易第一平台。',
                    ],
                    en_text: [
                        "Jianxue Xiao served in the Standing Committee of the National People's Congress (NPCSC) and later China Securities Regulatory Commission (CSRC) from 2004 to 2014, during which he has developed expertise in M&A laws and regulations. ",
                        'In October 2014, Jianxue joined Zhongzhi Enterprise Group where he was responsible for facilitating investments, mergers and acquisitions. He successfully led the acquisitions of Beilu Pharmaceutical (300016.SZ) and Guirenniao (603555.SH), respectively. After the acquisition of Shenzhen Success Electronics (002289.SZ) Jianxue served as CEO of the company, and settled the long-standing conflict between shareholders through successful ALM. By removing NPA, he helped Success Electronics get rid of the special treatment (ST) designation as a listed company.     ',
                        'In 2015, Jianxue served as assistant president of Evergrande Financial Group and president of the asset management department concurrently, responsible for the license acquisitions of securities, trusts and public funds. Recently, he is assisting Sichuan Luzhou city government in bankruptcy reorganization and reform of Lutianhua (000912.SZ).',
                        'In September 2018, Jianxue joined Unicorn Selected as co-founder.',
                    ],
                },
                {
                    name: '杨培琴',
                    en_name: 'Peiqin Yang',
                    img: 'http://static.unicornselected.com/b24aab00-0335-11eb-91c5-d550a48abe82.png',

                    text: [
                        '曾任职于德勤华永会计师事务所，负责多个国有企业IPO现场审计工作。',
                        '2009年于中国铝业公司任职，担任海外平台公司财务负责人，负责境外矿产资源并购工作，推进在澳大利亚、几内亚及东南亚等地的资源并购工作，拥有丰富的境外收购及投后管理经验。',
                        '2015年加入中植集团，并担任宇顺电子（002289）财务总监，任职期间成功解决宇顺电子巨额商誉、业绩承诺补偿等问题，并剥离了上市公司亏损资产，使宇顺电子成功保壳。',
                        '2018年9月作为联合创始人创立上海独易信息科技有限公司（亦名“独角汇”），力争打造中国独角兽私募股权交易第一平台。',
                    ],
                    en_text: [
                        'Peiqin Yang previously worked at Deloitte China, responsible for the on-site audit of IPOs of several state-owned enterprises. ',
                        'In 2009, Peiqin served in Aluminum Corporation of China, where she was in charge of the finance of overseas platform companies and M&A of mineral resources. With extensive experience in overseas acquisition and post-investment management, she facilitated M&A deals of resources in Australia, Guinea and Southeast Asia.',
                        'In 2015, Peiqin joined Zhongzhi Enterprise Group and served as CFO for Shenzhen Success Electronics (002289.SZ). During her tenure, she successfully resolved the issue of reputation and performance commitment compensations of the company, and played a critical role in helping Success Electronics remove the special treatment (ST) designation by divesting NPA.',
                        'In September 2018, Peiqin joined Unicorn Selected as co-founder.',
                    ],
                },
            ],
        };
    },
    watch: {
        cardIndex: {
            handler: function(params) {
                this.thisCardInfo = this.peopleDetail[params];
            },
            deep: true,
        },
    },
    methods: {
        close() {
            this.show = false;
            this.$emit('open-scroll');
        },
    },
};
</script>
